import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

import CurrencyCell from "../../../component/CurrencyCell";


const parseAmount = (value) => {
  if (value == null) return 0;

  let str = String(value).replace(/,/g, "").trim();

  // Handle trailing minus
  if (str.endsWith("-")) {
    str = "-" + str.slice(0, -1);
  }

  return Number(str) || 0;
};


export default function WGRTable({
  rows,
  shop,
  totals,
  showTotal = true,
}) {
  return (
    <TableContainer>
      <Table
        size="small"
        stickyHeader
      >
      <TableHead>
  <TableRow>
    <TableCell
      align="left"
      sx={{ fontWeight: "bold" }}
    >
      Sr No.
    </TableCell>

    <TableCell
      align="left"
      sx={{ fontWeight: "bold" }}
    >
      Description
    </TableCell>

    <TableCell
      align="right"
      sx={{ fontWeight: "bold" }}
    >
      Openning Balance
    </TableCell>

<TableCell
      align="right"
      sx={{ fontWeight: "bold" }}
    >
      Dr Amount
    </TableCell>

<TableCell
      align="right"
      sx={{ fontWeight: "bold" }}
    >
      Cr Amount
    </TableCell>

<TableCell
      align="right"
      sx={{ fontWeight: "bold" }}
    >
      Closing Balance
    </TableCell>

  </TableRow>
</TableHead>

        <TableBody>
          {rows.map((row, index) => {
 
  return (
    <TableRow
      key={index}
      hover
      sx={{
        "&:nth-of-type(even)": {
          bgcolor: "grey.50",
        },
      }}
    >

       <TableCell colSpan={1} align="left">{row.SrNo}</TableCell>
      <TableCell colSpan={1} align="left">{row.Description}</TableCell>

      <TableCell align="right">
        <CurrencyCell value={row.OB} />
      </TableCell>
<TableCell align="right">
        <CurrencyCell value={row.DEBIT} />
      </TableCell>
      <TableCell align="right">
        <CurrencyCell value={row.CREDIT} />
      </TableCell>
<TableCell align="right">
        <CurrencyCell value={row.CB} />
      </TableCell>
      
    </TableRow>
  );
})}

          {showTotal && (
            <TableRow
              sx={{
                bgcolor: "primary.light",
                "& td": {
                  fontWeight: 700,
                  borderTop: "2px solid",
                  borderColor: "primary.main",
                },
              }}
            >

               <TableCell colSpan={1} align="right">
              
              </TableCell>


              <TableCell colSpan={1} align="right">
               Total Amount
              </TableCell>

             

              <TableCell align="right">
                <CurrencyCell value={totals.OB} />
              </TableCell>

               <TableCell align="right">
                <CurrencyCell value={totals.DEBIT} />
              </TableCell>
               <TableCell align="right">
                <CurrencyCell value={totals.CREDIT} />
              </TableCell>
               <TableCell align="right">
                <CurrencyCell value={totals.CB} />
              </TableCell>
               

            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}